var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-squad-summary.c3d6be80.png",
    width: 20,
    height: 20
});